import Action from "./Action.vue";
import Container from "./Container.vue";
import Root from "./Root.vue";

export default {
  Action,
  Container,
  Root,
};
